import { render, staticRenderFns } from "./robotizationlabel.vue?vue&type=template&id=3c4f48e1&scoped=true&"
import script from "./robotizationlabel.vue?vue&type=script&lang=js&"
export * from "./robotizationlabel.vue?vue&type=script&lang=js&"
import style0 from "./robotizationlabel.vue?vue&type=style&index=0&id=3c4f48e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4f48e1",
  null
  
)

export default component.exports